export function joinUrl(partA, partB) {
  if (/^http/.test(partB)) {
    return partB;
  }
  const parts = [];
  if (partA.match(/\/$/)) {
    parts.push(partA.substr(0, partA.length - 1));
  } else {
    parts.push(partA);
  }
  if (partB.match(/^\//)) {
    parts.push(partB.substr(1));
  } else {
    parts.push(partB);
  }
  const joinedUrl = parts.join('/');
  try {
    return new URL(joinedUrl).href;
  } catch (err) {
    return joinedUrl;
  }
}
export function mergeOptions(...args) {
  return args.reduce((accumulator, src = {}) => ({
    ...accumulator,
    ...src,
    headers: {
      ...accumulator.headers,
      ...src.headers
    }
  }), {});
}
export function hasQuery(url) {
  return url.indexOf('?') > -1;
}
export function serializeQuery(params) {
  return Object.keys(params).reduce((query, param) => {
    if (params[param] !== undefined) {
      if (Array.isArray(params[param])) {
        query.push(params[param].map(value => `${encodeURIComponent(param)}=${encodeURIComponent(value)}`).join('&'));
      } else {
        query.push(`${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`);
      }
    }
    return query;
  }, []).join('&');
}
export function upgradeError(error) {
  error.isTimeoutError = () => !!error.toString().match(/network timeout/);
  return error;
}
export function upgradeResponse(response) {
  let contentType = '';
  if (response && response.headers && response.headers.get('Content-Type')) {
    contentType = response.headers.get('Content-Type').split(';')[0];
  }
  switch (contentType.toLowerCase()) {
    case 'json':
    case 'application/json':
      return response.json().then(json => {
        response.data = json;
        return response;
      }).catch(err => {
        err.name = 'FetcherParseError';
        err.message = "Couldn't parse response from json.";
        return Promise.reject(err);
      });
    case 'application/zip':
    case 'application/pdf':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return response.blob().then(blob => {
        response.data = blob;
        return response;
      }).catch(err => {
        err.name = 'FetcherParseError';
        err.message = "Couldn't parse response from blob.";
        return Promise.reject(err);
      });
    default:
      return response.text().then(text => {
        response.data = text;
        return response;
      }).catch(err => {
        err.name = 'FetcherParseError';
        err.message = "Couldn't parse response from text.";
        return Promise.reject(err);
      });
  }
}
export function computeBodyAndOptions(body, options = {}) {
  const newOptions = {
    ...options
  };
  const isMultipart = newOptions.headers && newOptions.headers['Content-Type'] === 'multipart/form-data';
  if (isMultipart) {
    delete newOptions.headers['Content-Type'];
    return {
      body,
      ...newOptions
    };
  }
  if (body !== null && typeof body === 'object') {
    if (!newOptions.headers) {
      newOptions.headers = {};
    }
    if (!newOptions.headers['Content-Type']) {
      newOptions.headers['Content-Type'] = 'application/json';
    }
    return {
      body: JSON.stringify(body),
      ...newOptions
    };
  }
  return {
    body,
    ...newOptions
  };
}